import DocumentItem from './DocumentItem'
import { useEffect, useState } from 'react'
import { IService } from '../../types/services'
import { makeStyles } from '@material-ui/core/styles'
import { getServices } from '../../services/services'
import Alert, { ActionsOptType } from '../../components/Alert'
import { Container, Grid, Typography } from '@material-ui/core'
// import { useHistory } from 'react-router'
// import { useSession } from '../../context/SessionContext'

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  addTemplate: {
    maxWidth: '60vw',
    marginBottom: '2vh',
  },
}))

/**
 * Custom `DocuemntsList` component declaration.
 * @return DocuemntsList
*/
const DocuemntsList = (): JSX.Element => {
  const classes = useStyles()
  // const history = useHistory()
  // const { user } = useSession()
  const [services, setServices] = useState<IService[] | null>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  // Load list services
  useEffect(() => {
    const fetchData = async () => {
      const { data, error } = await getServices()
      if (data) setServices(data)
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
    if (!services) {
      fetchData()
    }
  }, [])

  // show list services
  return (
    <Container className={classes.cardGrid} maxWidth="md">
      <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
      <Typography
        component="p"
        variant="body1"
        align="center"
        color="textPrimary"
        gutterBottom
        style={{ fontSize: '2rem', fontWeight: 'bold' }}
      >
        Tu lista de solicitudes
      </Typography>
      <Typography 
        variant="h6"
        align="center"
        color="textSecondary"
        paragraph
        style={{ marginBottom: '35px' }}
      >
        Para descargar tu documento haz click en el recuadro del documento correspondiente y en la parte superior derecha del documento encontrarás el ícono para descarga en formato PDF.
      </Typography>
    
      {/* Map list services with documentItem component */}
      <Grid container justifyContent="center" spacing={4}>
        {services ? (
          services.map((service: IService, index: number) => (
            <Grid item key={index} xs={12} sm={6} md={4}>
              <DocumentItem service={service} />
            </Grid>
          ))
        ) : (
          <></>
        )}
      </Grid>
    </Container>
  )
}

export default DocuemntsList